<template>
  <v-container
    fluid
    v-bind:class="{ 'no-padding': desktopOptimizedSwitch && currentStep !== 1 }"
  >

      <!--
      <pre>
      {{ schemaService }}
      </pre>
      -->

    <v-row
      v-if="this.$store.state.wgkStepsValid[currentWgkGroup].hasData"
    >
      <v-col style="position: relative;">
        <div v-if="loading" class="step-loading"></div>
          <form-generator :schema="schemaService"
                          v-model="formData">
          </form-generator>

        <v-alert
          v-if="!valid && showValidation"
          dense
          outlined
          type="error"
        >
          {{ this.$store.state.wgkStepsValid[currentWgkGroup].msg }}
        </v-alert>
      </v-col>
    </v-row>

  </v-container>

</template>

<script>

import {mapState} from "vuex";
import FormGenerator from "./FormGenerator";

export default {
  name: "Step.vue",
  components: { FormGenerator },
  props: [
    'currentStep',
    'currentWgkGroup',
    'validateMe'
  ],
  data () {
    return {
      schema: [],
      showValidation: false
    }
  },
  created() {
    if (this.validateMe !== '') {
      this.showValidation = true;
    }
    this.validation();
  },
  computed: {
    loading: function() {
      return this.$store.state.wgkStepsLoadingStatus[this.currentWgkGroup];
    },
    formData: {
      get () {
        let getMe = this.$store.state.wgkStepsValues[this.currentWgkGroup][0];
        if (typeof getMe !== 'undefined') {
          return getMe;
        }
        return {}
      },
      set (value) {
        //console.log('set change');
        this.$store.dispatch('updateWgkStepsValues', {[this.currentWgkGroup]:[value]}).then(() => {
          // on desktop variant update on every filter changes on step 2-4
          //if (this.desktopOptimizedSwitch && this.currentStep !== 1) {
          //if (this.desktopOptimizedSwitch) {
            // if clicked on an step not the current we will update by global step change watcher
            if(this.currentStep !== this.$store.state.wgkCurrentStep) {
              //console.log('desktop schema force over step')
              this.$store.commit('SET_WGK_CURRENT_STEP', this.currentStep)
            } else {
              //console.log('schema force desktop')
              this.$store.dispatch('forceSchemaUpdate', this.currentStep);
            }
          //}

          // on default wizard we have to force schema update before last step
          /*
          if (!this.desktopOptimizedSwitch && this.currentStep === 3) {
            //console.log('schmea update beofre last step');
            this.$store.dispatch('forceSchemaUpdate', this.currentStep);
          }*/

          // and for all other we will react on step change

        });


      }
    },
    valid: function () {
      return this.$store.state.wgkStepsValid[this.currentWgkGroup].valid
    },
    ...mapState({
      desktopOptimizedSwitch: state => state.desktopOptimizedSwitch,
      wgkGroups: state => state.wgkGroups,
      wgkStepsValues: state => state.wgkStepsValues,
      schemaService (state) {
        let currentSchema = [];
        switch (this.currentStep) {
          case 1:
            currentSchema =  state.wgkStepsSchema1
            break;
          case 2:
            currentSchema =  state.wgkStepsSchema2
            break;
          case 3:
            currentSchema =  state.wgkStepsSchema3
            break;
          case 4:
            currentSchema =  state.wgkStepsSchema4
            break;
        }
        return currentSchema;
      }
    })
  },
  methods: {
    validation() {

      let schemaGroupsStep1 = {};
      let valid = false;
      let msg = 'Bitte nehmen Sie eine Auswahl vor';


      switch (this.currentStep) {
      case 1:

        msg = 'Bitte nehmen Sie pro Kategorie eine Auswahl vor';

        // build schema object for prop length comparison with form data
        // on step1 every radio group must be valid = one option selected
        this.schemaService[0].children.forEach(function(item){
          schemaGroupsStep1[item.name] = '';
        });

        if (Object.keys(this.formData).length === Object.keys(schemaGroupsStep1).length) {
          valid = true;
        }

        break;
      case 2:
        for (let prop in this.formData) {
          if(this.formData[prop].length > 0) {
            valid = true;
          }
        }
        break;
      case 3:
        msg = 'Bitte nehmen Sie pro Kategorie eine Auswahl vor';
        valid = this.categoryValidation();
        break;
      case 4:
        valid = true;
      }

      this.$store.commit('SET_WGK_STEPS_VALID_STATUS', {
        group: this.currentWgkGroup,
        valid: valid,
        msg: msg
      })



    },
    categoryValidation() {

      let valid = false;
      let formValues = this.formData[Object.keys(this.formData)[0]];
      let groupValid = {};

      // if some selected
      if (typeof formValues !== 'undefined' && formValues.length > 0) {

        // iterate over schema option groups
        Object.entries(this.schemaService[0].children[0].optionGroups).forEach(([parentKey, options]) => {
          groupValid[parentKey] = false;
          // check for every category if formData has some value in it
          Object.entries(options).forEach(([key]) => {
            // if in formdata set category propertie to true
            if (formValues.includes(key)) {
              groupValid[parentKey] = true;
            }
          });

        });

        // check if all categories are true
        let allTrue = Object.keys(groupValid).every(function(k){ return groupValid[k] === true });
        if (allTrue) {
          valid = true;
        }
      }

      return valid;
    }
  },
  watch: {
    validateMe: {
      handler() {
        this.showValidation = true;
      }
    },

    formData: {
      deep: true,
      handler() {
        this.validation();
      }
    },
  },
}
</script>

<style lang="scss">

@import '../../src/sass/variables.scss';

.step-loading {
  position: absolute;
  height: 100%;
  width: 100%;
  background-image: url('~@/assets/background-loader.svg');
  background-position: center;
  background-size: 30%;
  background-color: rgba(245,245,245,0.6);
  z-index: 1;
}

.no-padding {
  padding: 0;
}

</style>
